function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BankAccountStatusTypes, PlaidBankAccountStatusTypes } from "./payment-method";
export let RelationshipFundingSourceType = /*#__PURE__*/function (RelationshipFundingSourceType) {
  RelationshipFundingSourceType["CreditCard"] = "creditCard";
  RelationshipFundingSourceType["BankAccount"] = "ach";
  return RelationshipFundingSourceType;
}({});
export let FundingSourceActiveStatus = /*#__PURE__*/function (FundingSourceActiveStatus) {
  FundingSourceActiveStatus["Active"] = "active";
  FundingSourceActiveStatus["Inactive"] = "inactive";
  return FundingSourceActiveStatus;
}({});
export class RelationshipFundingSourceModel {
  constructor(dto) {
    this.dto = dto;
  }
  id() {
    return this.dto.id;
  }
  isCreditCard() {
    return this.dto.type === RelationshipFundingSourceType.CreditCard;
  }
  isPlaidVerification() {
    return this.dto.type === RelationshipFundingSourceType.BankAccount && this.dto.ach.status === BankAccountStatusTypes.PlaidVerification;
  }
  isPendingAutomaticVerification() {
    return this.dto.type === RelationshipFundingSourceType.BankAccount && this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingAutomaticVerification;
  }
  last4() {
    return this.dto ? this.dto.last4 : null;
  }
  isPendingMicroDeposit() {
    return this.dto.type === RelationshipFundingSourceType.BankAccount && (this.dto.ach.status === BankAccountStatusTypes.New || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingManualVerification || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingAutomaticVerification);
  }
  failedVerification() {
    return this.dto.type === RelationshipFundingSourceType.BankAccount && (this.dto.ach.status === BankAccountStatusTypes.TwoAttemptsFailed || this.dto.ach.status === BankAccountStatusTypes.VerificationFailed || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.VerificationFailed || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.VerificationExpired);
  }
  isVerified() {
    return this.dto.type === RelationshipFundingSourceType.BankAccount && this.dto.ach.status === BankAccountStatusTypes.Verified;
  }
  canCompleteVerification() {
    return this.dto.type === RelationshipFundingSourceType.BankAccount && (this.dto.ach.status === BankAccountStatusTypes.New || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingManualVerification);
  }
  setPlaidVerificationStatus(plaidVerificationStatus) {
    if (this.dto.type === RelationshipFundingSourceType.CreditCard) {
      return this;
    }
    return new RelationshipFundingSourceModel(_objectSpread(_objectSpread({}, this.dto), {}, {
      ach: _objectSpread(_objectSpread({}, this.dto.ach), {}, {
        plaidVerificationStatus
      })
    }));
  }
}